const getTargetElementType = (elements, matchedSettings) => {
  const element = elements.find(Boolean);

  if (!element) return null;

  const settingWithType = matchedSettings.find(
    (setting) => typeof setting.getTargetElementType === 'function'
  );

  if (!settingWithType) return null;

  return settingWithType.getTargetElementType(element, settingWithType.settings);
};

export default getTargetElementType;
